import { useQuery } from 'react-query'
import { CardMetrica, EstadoSecao } from '../components/comuns'
import { getIndicadoresInterconsulta } from '../core/_requests'
import { formatarContagem, formatarHoras, formatarNota } from '../core/filtro'
import { useParametrosRelatorios } from '../core/ListFiltersProvider'

const NOTAS = ['1', '2', '3', '4', '5']

/** Indicadores do período: volume, faixas de tempo de resposta (prazo de 72h) e satisfação (meta > 3). */
export const SecaoIndicadores = () => {
  const { periodo: parametros } = useParametrosRelatorios()
  const { data, isFetching, isError, refetch } = useQuery(
    ['interconsulta-relatorio-indicadores', parametros],
    () => getIndicadoresInterconsulta(parametros!),
    { enabled: !!parametros, refetchOnWindowFocus: false, retry: false }
  )

  const tempo = data?.tempoResposta
  const satisfacao = data?.satisfacao
  const metaTexto =
    satisfacao?.metaAtingida === true
      ? 'Meta atingida (média acima de 3)'
      : satisfacao?.metaAtingida === false
      ? 'Meta não atingida (média até 3)'
      : 'Sem avaliações para a meta'

  return (
    <section aria-label='Indicadores da interconsulta' className='card-body pt-4'>
      <EstadoSecao
        semFiltro={!parametros}
        carregando={isFetching && !data}
        erro={isError}
        vazio={data?.total === 0}
        onRetry={refetch}
      >
        {data && tempo && satisfacao && (
          <>
            <h2 className='fs-5 fw-bold text-gray-900 mb-4'>Volume</h2>
            <div className='row g-4 mb-8'>
              <div className='col-md-6 col-xl-3'>
                <CardMetrica titulo='Interconsultas' valor={formatarContagem(data.total)} />
              </div>
              <div className='col-md-6 col-xl-3'>
                <CardMetrica titulo='Respondidas' valor={formatarContagem(data.respondidas)} />
              </div>
              <div className='col-md-6 col-xl-3'>
                <CardMetrica titulo='Canceladas' valor={formatarContagem(data.canceladas)} />
              </div>
              <div className='col-md-6 col-xl-3'>
                <CardMetrica
                  titulo='Sem lotação do solicitante'
                  valor={formatarContagem(data.semLotacaoSolicitante)}
                  apoio='Ficam incompletas no relatório mensal'
                />
              </div>
            </div>

            <h2 className='fs-5 fw-bold text-gray-900 mb-4'>Tempo de resposta</h2>
            <div className='row g-4 mb-8'>
              <div className='col-md-6 col-xl-3'>
                <CardMetrica
                  titulo='Até 72 horas'
                  valor={formatarContagem(tempo.ate72h)}
                  apoio='Dentro do prazo do edital'
                />
              </div>
              <div className='col-md-6 col-xl-3'>
                <CardMetrica titulo='De 72 a 144 horas' valor={formatarContagem(tempo.de72a144h)} />
              </div>
              <div className='col-md-6 col-xl-3'>
                <CardMetrica
                  titulo='Acima de 144 horas'
                  valor={formatarContagem(tempo.acima144h)}
                />
              </div>
              <div className='col-md-6 col-xl-3'>
                <CardMetrica
                  titulo='Mediana'
                  valor={formatarHoras(tempo.medianaHoras)}
                  apoio={`Média ${formatarHoras(tempo.mediaHoras)} · ${formatarContagem(
                    tempo.n
                  )} respondidas`}
                />
              </div>
            </div>

            <h2 className='fs-5 fw-bold text-gray-900 mb-4'>Satisfação do solicitante</h2>
            <div className='row g-4'>
              <div className='col-md-6 col-xl-3'>
                <CardMetrica
                  titulo='Média (1 a 5)'
                  valor={formatarNota(satisfacao.media)}
                  apoio={`${metaTexto} · ${formatarContagem(satisfacao.n)} avaliações`}
                />
              </div>
              <div className='col-md-6 col-xl-9'>
                <div className='card card-flush h-100 border border-gray-300'>
                  <div className='card-body p-6'>
                    <h3 className='fs-6 fw-semibold text-gray-700 mb-3'>Distribuição das notas</h3>
                    <div className='table-responsive'>
                      <table className='table table-row-bordered align-middle mb-0'>
                        <caption className='visually-hidden'>
                          Quantidade de avaliações por nota de satisfação
                        </caption>
                        <thead>
                          <tr className='fw-semibold text-gray-700'>
                            {NOTAS.map((nota) => (
                              <th key={nota} scope='col' className='text-center'>
                                Nota {nota}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          <tr className='text-gray-900'>
                            {NOTAS.map((nota) => (
                              <td key={nota} className='text-center fw-bold fs-4'>
                                {formatarContagem(satisfacao.distribuicao?.[nota] ?? 0)}
                              </td>
                            ))}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </EstadoSecao>
    </section>
  )
}
